<template>
  <Calendar v-model="model" v-bind="$props" />
</template>

<script>
import { useField } from "vee-validate";
import { mapActions } from "vuex";

export default {
  inheritAttrs: false,
  props: {
    modelValue: { type: [String, Array, Number], default: "" },
    name: { type: String },
    placeholder: { type: String },
    minDate: { type: Date, default: null },
    maxDate: { type: Date, default: null },
    showTime: { type: Boolean },
    hourFormat: { type: String },
  },
  data() {
    const {
      value: inputValue,
      errorMessage,
      handleChange,
      meta,
      resetField,
    } = useField(this.name, null, {
      initialValue: String(this.model || ""),
    });
    let data = {
      selectedItems: null,
      filteredItems: null,
    };

    return data;
  },
  mounted() {},
  methods: {
    ...mapActions("fetch", ["fetch"]),
    fetchAll(data) {
      return this.fetch(data).then((res) => {
        this.filteredItems = res;
      });
    },
  },

  computed: {
    model: {
      get() {
        return this.modelValue || null;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
